import { render, staticRenderFns } from "./RoomCardTag.vue?vue&type=template&id=299284dc&"
import script from "./RoomCardTag.vue?vue&type=script&lang=js&"
export * from "./RoomCardTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports